import {UID} from "agora-rtc-sdk-ng";
import {UserTracks} from "@share/web-conferences/types/UserTracks";

const screenShareUidPrefix = 'user-';

/**
 * checks if the given id contains screen share prefix which means the user is the screen sharing user
 * @param uid
 */
export const isShareScreen = (uid: string) => {
    return uid.toString().startsWith(screenShareUidPrefix);
}

/**
 * Checks if a particular user is the sharing screen user
 * @param uid
 * @param sharingUid
 */
export const isUserSharing = (uid: UID, sharingUid: UID) => {
    return `${screenShareUidPrefix}${uid}` == sharingUid;
}

/**
 * Finds scharing user tracks in the list
 * @param tracks
 */
export const findSharingTrackIndex = (tracks: Record<UID, UserTracks>) => {
    return Object.values(tracks).findIndex(item => item.isScreenShare);
}
